
import React, { useState } from 'react';
import { casinoQuizQuestions, casinoRecommendations } from '../../../mocks/quizQuestions';
import { topCasinos } from '../../../mocks/casinos';

export const CasinoQuizSection: React.FC = () => {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState<Record<number, string>>({});
  const [scores, setScores] = useState({ bonus: 0, speed: 0, games: 0, mobile: 0 });
  const [showResult, setShowResult] = useState(false);
  const [isStarted, setIsStarted] = useState(false);

  const handleAnswer = (questionId: number, optionId: string, points: { bonus: number; speed: number; games: number; mobile: number }) => {
    setAnswers({ ...answers, [questionId]: optionId });
    setScores({
      bonus: scores.bonus + points.bonus,
      speed: scores.speed + points.speed,
      games: scores.games + points.games,
      mobile: scores.mobile + points.mobile
    });

    if (currentQuestion < casinoQuizQuestions.length - 1) {
      setTimeout(() => setCurrentQuestion(currentQuestion + 1), 300);
    } else {
      setTimeout(() => setShowResult(true), 300);
    }
  };

  const getRecommendedCasino = () => {
    let bestMatch = casinoRecommendations[0];
    let bestScore = 0;

    casinoRecommendations.forEach(rec => {
      const matchScore = 
        (rec.matchCriteria.bonus <= scores.bonus ? 1 : 0) +
        (rec.matchCriteria.speed <= scores.speed ? 1 : 0) +
        (rec.matchCriteria.games <= scores.games ? 1 : 0) +
        (rec.matchCriteria.mobile <= scores.mobile ? 1 : 0);
      
      if (matchScore > bestScore) {
        bestScore = matchScore;
        bestMatch = rec;
      }
    });

    const casino = topCasinos.find(c => c.name.toLowerCase().includes(bestMatch.id)) || topCasinos[0];
    return { recommendation: bestMatch, casino };
  };

  const resetQuiz = () => {
    setCurrentQuestion(0);
    setAnswers({});
    setScores({ bonus: 0, speed: 0, games: 0, mobile: 0 });
    setShowResult(false);
    setIsStarted(false);
  };

  const progress = ((currentQuestion + 1) / casinoQuizQuestions.length) * 100;

  if (!isStarted) {
    return (
      <section className="py-20 bg-gradient-to-br from-rose-50 via-white to-amber-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 text-center">
            <div className="w-20 h-20 bg-gradient-to-br from-rose-500 to-amber-500 rounded-2xl flex items-center justify-center mx-auto mb-6">
              <i className="ri-questionnaire-line text-white text-3xl"></i>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Тест: Какое <span className="text-rose-600">мобильное казино онлайн</span> вам подходит?
            </h2>
            <p className="text-gray-600 mb-8 max-w-xl mx-auto">
              Ответьте на 7 простых вопросов, и мы подберем идеальное онлайн казино 
              специально для вас на основе ваших предпочтений
            </p>
            <div className="flex flex-wrap justify-center gap-4 mb-8">
              <div className="flex items-center gap-2 text-sm text-gray-500">
                <i className="ri-time-line text-rose-500"></i>
                <span>2 минуты</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-500">
                <i className="ri-question-line text-rose-500"></i>
                <span>7 вопросов</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-500">
                <i className="ri-gift-line text-rose-500"></i>
                <span>Персональная рекомендация</span>
              </div>
            </div>
            <button
              onClick={() => setIsStarted(true)}
              className="px-8 py-4 bg-gradient-to-r from-rose-600 to-amber-600 text-white rounded-xl font-semibold text-lg hover:shadow-lg transition-all cursor-pointer whitespace-nowrap"
            >
              Начать тест
              <i className="ri-arrow-right-line ml-2"></i>
            </button>
          </div>
        </div>
      </section>
    );
  }

  if (showResult) {
    const { recommendation, casino } = getRecommendedCasino();
    
    return (
      <section className="py-20 bg-gradient-to-br from-rose-50 via-white to-amber-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-3xl shadow-xl overflow-hidden">
            <div className="bg-gradient-to-r from-rose-600 to-amber-600 p-6 text-center text-white">
              <i className="ri-trophy-line text-4xl mb-2"></i>
              <h3 className="text-2xl font-bold">Ваше идеальное казино найдено!</h3>
            </div>
            
            <div className="p-8">
              <div className="flex flex-col md:flex-row gap-6 items-center mb-8">
                <div className="w-32 h-40 rounded-2xl overflow-hidden flex-shrink-0">
                  <img src={casino.image} alt={casino.name} className="w-full h-full object-cover" />
                </div>
                <div className="text-center md:text-left">
                  <div className="flex items-center justify-center md:justify-start gap-2 mb-2">
                    <span className="px-3 py-1 bg-emerald-100 text-emerald-700 rounded-full text-sm font-medium">
                      Лучший выбор для вас
                    </span>
                  </div>
                  <h4 className="text-2xl font-bold text-gray-900 mb-2">{casino.name}</h4>
                  <p className="text-gray-600 mb-4">{recommendation.description}</p>
                  <div className="flex flex-wrap justify-center md:justify-start gap-3">
                    <span className="px-3 py-1.5 bg-rose-50 text-rose-700 rounded-lg text-sm">
                      <i className="ri-gift-line mr-1"></i>{casino.bonus}
                    </span>
                    <span className="px-3 py-1.5 bg-emerald-50 text-emerald-700 rounded-lg text-sm">
                      <i className="ri-time-line mr-1"></i>{casino.withdrawTime}
                    </span>
                    <span className="px-3 py-1.5 bg-sky-50 text-sky-700 rounded-lg text-sm">
                      <i className="ri-gamepad-line mr-1"></i>{casino.games} игр
                    </span>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
                <div className="bg-gray-50 rounded-xl p-4 text-center">
                  <div className="text-2xl font-bold text-rose-600">{scores.bonus}</div>
                  <div className="text-sm text-gray-600">Бонусы</div>
                </div>
                <div className="bg-gray-50 rounded-xl p-4 text-center">
                  <div className="text-2xl font-bold text-emerald-600">{scores.speed}</div>
                  <div className="text-sm text-gray-600">Скорость</div>
                </div>
                <div className="bg-gray-50 rounded-xl p-4 text-center">
                  <div className="text-2xl font-bold text-sky-600">{scores.games}</div>
                  <div className="text-sm text-gray-600">Игры</div>
                </div>
                <div className="bg-gray-50 rounded-xl p-4 text-center">
                  <div className="text-2xl font-bold text-amber-600">{scores.mobile}</div>
                  <div className="text-sm text-gray-600">Мобильность</div>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <button className="px-6 py-3 bg-gradient-to-r from-rose-600 to-amber-600 text-white rounded-xl font-semibold hover:shadow-lg transition-all cursor-pointer whitespace-nowrap">
                  Перейти в {casino.name}
                </button>
                <button
                  onClick={resetQuiz}
                  className="px-6 py-3 bg-gray-100 text-gray-700 rounded-xl font-semibold hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Пройти тест заново
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  const question = casinoQuizQuestions[currentQuestion];

  return (
    <section className="py-20 bg-gradient-to-br from-rose-50 via-white to-amber-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-3xl shadow-xl p-8">
          <div className="mb-8">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm text-gray-500">Вопрос {currentQuestion + 1} из {casinoQuizQuestions.length}</span>
              <span className="text-sm font-medium text-rose-600">{Math.round(progress)}%</span>
            </div>
            <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
              <div 
                className="h-full bg-gradient-to-r from-rose-500 to-amber-500 transition-all duration-500"
                style={{ width: `${progress}%` }}
              ></div>
            </div>
          </div>

          <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-6 text-center">
            {question.question}
          </h3>

          <div className="space-y-3">
            {question.options.map((option) => (
              <button
                key={option.id}
                onClick={() => handleAnswer(question.id, option.id, option.points)}
                className={`w-full p-4 rounded-xl border-2 text-left transition-all cursor-pointer ${
                  answers[question.id] === option.id
                    ? 'border-rose-500 bg-rose-50'
                    : 'border-gray-200 hover:border-rose-300 hover:bg-rose-50/50'
                }`}
              >
                <span className="font-medium text-gray-900">{option.text}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
